import React from "react";
//import {BrowserRouter as Router, Switch, Route, Link} from 'react-router-dom';
import Nav from "./nav";
import Game from "./Game.js"
function App() {
  return (
    <div>
      <Nav/>
      <Game/>
    </div>
  );
}
export default App;